import './css/App.css';
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import HomePage from './pages/Home/HomePage';
import Header from "./pages/Navigation/Header";
import Footer from "./pages/Navigation/Footer";
import Countries from "./pages/Countries/Countries";
import CountryDetails from "./pages/Countries/CountryDetails";
import Foods from "./pages/Foods/Foods";
import FoodDetails from "./pages/Foods/FoodDetails";
import Login from "./pages/Account/Login";
import TermsAndConditions from "./pages/Terms/TermsAndConditions";
import AboutUs from "./pages/AboutUs/AboutUs";
import { UserContextProvider } from "./contexts/UserContext";
import MyAccount from "./pages/Account/MyAccount";
import Logoff from "./pages/Account/Logoff";
import Signup from "./pages/Account/Signup";
import Landing	from "./pages/Home/Landing";

function App() {
  return (
	<div className="container-fluid">
	<UserContextProvider>
	 <Header />	
		<Routes>
			<Route path="/" element={<Landing />} />
		 	<Route path="/home" exact element={<HomePage signedIn={false}/>} />
		 	<Route path="/home_signin" exact element={<HomePage signedIn={true}/>} />
		 	<Route path="/countries" element={<Countries />} />
		 	<Route path="/countries/:countryCode" element={<CountryDetails />} />
		 	<Route path="/foods" element={<Foods />} />
		 	<Route path="/foods/:foodSlug" element={<FoodDetails />} />
		 	<Route path="/sign_in" element={<Login />} />
		 	<Route path="/terms" element={<TermsAndConditions isSubmit={false} />} />
		 	<Route path="/about" element={<AboutUs />} />
		 	<Route path="/termsSubmit" element={<TermsAndConditions isSubmit={true} />} />
		 	<Route path="/sign_up" element={<Signup />} />
		 	<Route path="/my_account" element={<MyAccount />} />
		 	<Route path="/sign_out" element={<Logoff />} />
		 	<Route path='*' element={<Navigate to="/sign_in" replace />} />
		</Routes>
   
     <Footer />
     </UserContextProvider>
    </div>
  );
}

export default App;
